export const getDefault = () => {
  // todo this image will only work on dev environment
  const defaultImage = {
    id: 68,
    alt: 'ua',
    title: 'ua',
    url: 'https://api-assets.dev.ua.pt/files/imgs/000/000/068/original.jpg',
    isLocal: false
  }
  const schema = {
    name: 'Slider',
    styles: {
      backgroundColor: 'rgba(230, 230, 230, 0.8)',
      textColor: '#000'
    },
    endpoint: '/news/top',
    data: {
      payload: null,
      list: [
        {
          image: defaultImage,
          description: 'Passe o rato por cima e clique no "lápis" de editação no canto superior direito',
          summary: '',
          title: 'Edite o destaque',
          url: 'https://www.ua.pt',
          displayTab: false,
          useInterval: false,
          startDate: null,
          endDate: null
        },
      ]
    }
  }
  return schema
}
